// Sidebar collapses at this viewport width. Below it, the 300x250 desktop ad
// renders in a hidden/too-narrow slot, destroying viewability — so we treat
// these viewports as mobile for ad-unit selection and serve the mobile unit
// instead. See CBUPT-51359.
export const MOBILE_AD_BREAKPOINT = 1100;

// True when the viewport is narrow enough that the mobile ad unit should be
// served. Width-only — user-agent isn't consulted, since the ticket is about
// layout viewability, not device class.
export default function shouldUseMobileAd() {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.innerWidth < MOBILE_AD_BREAKPOINT;
}
